import { createBrowserRouter, Navigate } from "react-router-dom";
import { Suspense, lazy } from "react";
import { Main } from "../views";
import { Loader } from "../components/Loader/Loader";
import { SITE_LINKS_SCHEMA } from "./navlinks";
import { Profile } from "../views";
const ForgotPassword = lazy(() =>
  import("../views").then((module) => ({ default: module.ForgotPassword }))
);
const AdminDashboard = lazy(() =>
  import("../views").then((module) => ({ default: module.AdminDashboard }))
);
const UserMangement = lazy(() =>
  import("../views").then((module) => ({ default: module.UserManagement }))
);
const DashBoard = lazy(() =>
  import("../views").then((module) => ({ default: module.Dashboard }))
);
const ProjectEngagements = lazy(() =>
  import("../views").then((module) => ({ default: module.ProjectEngagements }))
);
const PageNotFound = lazy(() =>
  import("../views").then((module) => ({ default: module.PageNotFound }))
);
const TimeSheet = lazy(() =>
  import("../views").then((module) => ({ default: module.TimeSheet }))
);
const Login = lazy(() =>
  import("../views").then((module) => ({ default: module.Login }))
);
const CreateResource = lazy(() =>
  import("../views").then((module) => ({ default: module.CreateResource }))
);
const UpdateResource = lazy(() =>
  import("../views").then((module) => ({ default: module.UpdateResource }))
);
const ResetPassword = lazy(() =>
  import("../views").then((module) => ({ default: module.ResetPassword }))
);
const TimesheetApproval = lazy(() =>
  import("../views").then((module) => ({ default: module.TimesheetApproval }))
);
const TimesheetApprovalDetails = lazy(() =>
  import("../views").then((module) => ({
    default: module.TimesheetApprovalDetails,
  }))
);
const TimesheetCorrectionView = lazy(() =>
  import("../views").then((module) => ({
    default: module.TimesheetCorrectionView,
  }))
);
const CreateProject = lazy(() =>
  import("../views").then((module) => ({ default: module.CreateProject }))
);
const UpdateProject = lazy(() =>
  import("../views").then((module) => ({ default: module.UpdateProject }))
);
const ForbiddenPage = lazy(() =>
  import("../views").then((module) => ({ default: module.ForbiddenPage }))
);
const Notifications = lazy(() =>
  import("../views").then((module) => ({ default: module.Notifications }))
);
const Settings = lazy(() =>
  import("../views").then((module) => ({ default: module.Settings }))
);
const Reports = lazy(() =>
  import("../views").then((module) => ({ default: module.Reports }))
);
const router = createBrowserRouter([
  {
    path: SITE_LINKS_SCHEMA.HOME,
    element: <Main />,
    children: [
      {
        index: true,
        element: (
          <Navigate to={`${SITE_LINKS_SCHEMA.DASHBOARD}?fromIndexRoute=true`} />
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.ADMIN_DASHBOARD,
        element: (
          <Suspense fallback={<Loader />}>
            <AdminDashboard />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.DASHBOARD,
        element: (
          <Suspense fallback={<Loader />}>
            <DashBoard />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.NOTIFICATIONS,
        element: (
          <Suspense fallback={<Loader />}>
            <Notifications />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.LOGIN,
        element: (
          <Suspense fallback={<Loader />}>
            <Login isAuthPage={true} />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.FORGOT_PASS,
        element: (
          <Suspense fallback={<Loader />}>
            <ForgotPassword />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.RESET_PASS,
        element: (
          <Suspense fallback={<Loader />}>
            <ResetPassword />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.USER_MANAGEMENT,
        element: (
          <Suspense fallback={<Loader />}>
            <UserMangement />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.PROFILE,
        element: <Profile />,
      },
      {
        path: SITE_LINKS_SCHEMA.CREATE_RESOURCE,
        element: (
          <Suspense fallback={<Loader />}>
            <CreateResource />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.UPDATE_RESOURCE,
        element: (
          <Suspense fallback={<Loader />}>
            <UpdateResource />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.PROJECT_ENGAGEMENTS,
        element: (
          <Suspense fallback={<Loader />}>
            <ProjectEngagements />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.PROJECT_CREATION,
        element: (
          <Suspense fallback={<Loader />}>
            <CreateProject />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.PROJECT_UPDATE,
        element: (
          <Suspense fallback={<Loader />}>
            <UpdateProject />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.TIME_SHEET_MANAGEMENT,
        element: (
          <Suspense fallback={<Loader />}>
            <TimeSheet />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.SETTINGS,
        element: (
          <Suspense fallback={<Loader />}>
            <Settings />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.REPORTS,
        element: (
          <Suspense fallback={<Loader />}>
            <Reports />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.TIME_SHEET_APPROVAL,
        element: (
          <Suspense fallback={<Loader />}>
            <TimesheetApproval />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.TIME_SHEET_APPROVAL_DETAILS,
        element: (
          <Suspense fallback={<Loader />}>
            <TimesheetApprovalDetails />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.TIME_SHEET_CORRECTION_DETAILS,
        element: (
          <Suspense fallback={<Loader />}>
            <TimesheetCorrectionView />
          </Suspense>
        ),
      },
      {
        path: SITE_LINKS_SCHEMA.FORBIDDEN,
        element: (
          <Suspense fallback={<Loader />}>
            <ForbiddenPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: SITE_LINKS_SCHEMA.PAGE_NOT_FOUND,
    element: (
      <Suspense fallback={<Loader />}>
        <PageNotFound />
      </Suspense>
    ),
  },
]);

export default router;
